import React from 'react';

const DIGITS = '0123456789'.split('');

/**
 * A number that rolls up into place as it shows (Motion and Brand spec §2.1,
 * ink.css .ink-roll): each digit a column of 0–9 sliding to its value, 90ms
 * after the one before; separators and units ("," "." "%" "K" "/" "−") stay
 * put. A screen reader hears the whole number. It rolls again whenever the
 * number changes. Pass a number (shown with toLocaleString) or text that's
 * already formatted ("286K", "10.8%", "3 / 10").
 */
export function RollNumber({ value }: { value: number | string }) {
  const text = typeof value === 'number' ? value.toLocaleString() : value;
  return (
    <span key={text} className="ink-roll" role="img" aria-label={text}>
      {[...text].map((ch, i) =>
        /\d/.test(ch) ? (
          <span key={i} className="ink-roll-digit">
            <span
              className="ink-roll-col"
              style={{ '--v': ch, animationDelay: `${i * 90}ms` } as React.CSSProperties}
            >
              {DIGITS.map((d) => (
                <span key={d}>{d}</span>
              ))}
            </span>
          </span>
        ) : (
          <span key={i} className="ink-roll-char">
            {ch === ' ' ? ' ' : ch}
          </span>
        )
      )}
    </span>
  );
}
